module.exports = __webpack_public_path__ + "img/word.80628786.png";